import React, { useEffect, useState, useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface AdDisplayProps {
    campaignId: string;
    adVariationId?: string;
    imageUrl?: string;
    videoUrl?: string;
}

/**
 * AdDisplay component - Used to display ads to end users
 * Analytics tracking is disabled for CruiseClick platform as tracking will be done
 * on the platforms where the ads are embedded
 */
const AdDisplay: React.FC<AdDisplayProps> = ({ 
    campaignId, 
    adVariationId, 
    imageUrl, 
    videoUrl 
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const adRef = useRef<HTMLDivElement>(null);
    
    // Handle loading state
    const handleLoaded = () => {
        setIsLoading(false);
    };
    
    return (
        <Box 
            ref={adRef}
            sx={{ 
                position: 'relative',
                width: '100%',
                minHeight: 200,
                cursor: 'pointer',
                border: '1px solid #eee',
                borderRadius: 1,
                overflow: 'hidden'
            }}
        >
            {isLoading && (
                <Box 
                    sx={{ 
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f5f5f5'
                    }}
                >
                    <CircularProgress size={30} />
                </Box>
            )}
            
            {videoUrl ? (
                <video
                    src={videoUrl}
                    controls
                    onLoadedData={handleLoaded}
                    style={{
                        width: '100%',
                        maxHeight: '100%',
                        display: isLoading ? 'none' : 'block'
                    }}
                />
            ) : imageUrl ? (
                <img
                    src={imageUrl}
                    alt="Advertisement"
                    onLoad={handleLoaded}
                    style={{
                        width: '100%',
                        height: 'auto',
                        display: isLoading ? 'none' : 'block'
                    }}
                />
            ) : (
                <Box 
                    sx={{ 
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#f5f5f5',
                        color: '#999',
                        p: 2
                    }}
                >
                    No ad content available
                </Box>
            )}
        </Box>
    );
};

export default AdDisplay; 